__turbopack_context__.v({
  "button": "XxjutG_button",
  "buttonText": "XxjutG_buttonText",
  "secondary": "XxjutG_secondary",
});
